export default function () {
    return {
        restrict: 'E',
        template: require('./enquiries-progress.html'),
        bindToController: {
            vehicleId: '=',
            display: '=',
            notes: '='
        },
        controller,
        controllerAs: 'enquiriesProgress'
    };
}

function controller(getEnquiriesProgress, $scope, $interval) {
    const vm = this;

    vm.list = [];

    /* -- */

    const oneMinuteTimelapse = 60 * 1000;
    let intervalIdentifiant = null;

    /* --- */

    const deregisterWatcher = $scope.$watch(() => vm.vehicleId && true, ready => {
        if (ready) {
            deregisterWatcher();
            retrieveAndStoreEnquiriesProgress();
            intervalIdentifiant = $interval(retrieveAndStoreEnquiriesProgress, oneMinuteTimelapse);
        }
    });

    $scope.$on('$destroy', () => {
        $interval.cancel(intervalIdentifiant);
    });

    /* --- */

    function retrieveAndStoreEnquiriesProgress() {
        getEnquiriesProgress(vm.vehicleId, vm.enquiryId)
        .then(result => {
            vm.list = result;
        });
    }
}



// WEBPACK FOOTER //
// ./Client/app/tasks/directives/enquiriesProgress/index.js